import ContextProvider from "@src/context/StoreContext"

// Shared by gatsby-browser.js and gatsby-ssr.js so the SSR output and the
// hydrated client tree are always wrapped identically.
const wrapRootElement = ({ element }) => {
  return <ContextProvider>{element}</ContextProvider>
}

export default wrapRootElement
